import { HttpMethodEnum, QuestelServicesClient } from '@questelservices/common';
import store from '@/store';
import { InvoiceLineItemUpdateCountryDto } from '@/models/InvoiceLineItemUpdateCountryDto';
import { InvoiceLineItemUpdateMatterNameDto } from '@/models/InvoiceLineItemUpdateMatterNameDto';
import { InvoiceLineItemApplyExchangeRateDto } from '@/models/invoice/InvoiceLineItemApplyExchangeRateDto';
import { InvoiceLineItemBulkApplyExchangeRateDto } from '@/models/invoice/InvoiceLineItemBulkApplyExchangeRateDto';
import { InvoiceLineItemBulkOperationResponseDto } from '@/models/invoice/InvoiceLineItemBulkOperationResponseDto';
import { InvoiceLineItemBulkUpdateInvoiceDateDto } from '@/models/invoice/InvoiceLineItemBulkUpdateInvoiceDateDto';
import { InvoiceLineItemBulkUpdateInvoiceNumberDto } from '@/models/invoice/InvoiceLineItemBulkUpdateInvoiceNumberDto';
import { InvoiceLineItemUpdateInvoiceDateDto } from '@/models/invoice/InvoiceLineItemUpdateInvoiceDateDto';
import { InvoiceLineItemUpdateInvoiceNumberDto } from '@/models/invoice/InvoiceLineItemUpdateInvoiceNumberDto';
import { InvoiceLineItemUpdateTotalDto } from '@/models/invoice/InvoiceLineItemUpdateTotalDto';
import { InvoiceLookupLineItemDto } from '@/models/invoice/InvoiceLookupLineItemDto';

export class InvoiceLineItemService {
  private client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/InvoiceLineItems');
  }

  public async updateLineItemCountryCodes(updateCountryDto: InvoiceLineItemUpdateCountryDto) {
    return await this.client.postJson('/update-country-code', updateCountryDto);
  }

  public async updateLineItemMatterName(updateMatterNameDto: InvoiceLineItemUpdateMatterNameDto) {
    return await this.client.postJson('/update-matter-name', updateMatterNameDto);
  }

  public async updateInvoiceDate(id: Guid, dto: InvoiceLineItemUpdateInvoiceDateDto): Promise<InvoiceLookupLineItemDto> {
    return await this.client.getData<InvoiceLookupLineItemDto>(HttpMethodEnum.Patch, `/${id}/invoice-date`, dto);
  }

  public async updateInvoiceNumber(id: Guid, dto: InvoiceLineItemUpdateInvoiceNumberDto): Promise<InvoiceLookupLineItemDto> {
    return await this.client.getData<InvoiceLookupLineItemDto>(HttpMethodEnum.Patch, `/${id}/invoice-number`, dto);
  }

  public async updateLineItemTotal(id: Guid, dto: InvoiceLineItemUpdateTotalDto): Promise<InvoiceLookupLineItemDto> {
    return await this.client.getData<InvoiceLookupLineItemDto>(HttpMethodEnum.Patch, `/${id}/line-item-total`, dto);
  }

  public async applyExchangeRate(id: Guid, dto: InvoiceLineItemApplyExchangeRateDto): Promise<InvoiceLookupLineItemDto> {
    return await this.client.getData<InvoiceLookupLineItemDto>(HttpMethodEnum.Patch, `/${id}/exchange-rate`, dto);
  }

  public async bulkUpdateInvoiceDate(dto: InvoiceLineItemBulkUpdateInvoiceDateDto): Promise<InvoiceLineItemBulkOperationResponseDto> {
    return await this.client.getPostData<InvoiceLineItemBulkOperationResponseDto>('/invoice-date', dto);
  }

  public async bulkUpdateInvoiceNumber(dto: InvoiceLineItemBulkUpdateInvoiceNumberDto): Promise<InvoiceLineItemBulkOperationResponseDto> {
    return await this.client.getPostData<InvoiceLineItemBulkOperationResponseDto>('/invoice-number', dto);
  }

  public async bulkApplyExchangeRate(dto: InvoiceLineItemBulkApplyExchangeRateDto): Promise<InvoiceLineItemBulkOperationResponseDto> {
    return await this.client.getPostData<InvoiceLineItemBulkOperationResponseDto>('/exchange-rate', dto);
  }
}
